import { createContext } from "react"
import { DraggableData, Positions } from "../types/study/PrimitiveChallengeTypes"

export const PrimitivesChallengeContext = createContext(
    {
        handleDrop: (draggableData: DraggableData, droppedPosition: Positions, expectedChar: number | null) => { }
    }
)
